import { useEffect, useRef } from 'react'
import ApexCharts from 'apexcharts'
import { getCSS } from '_metronic/assets/ts/_utils'
import { useThemeMode } from '_metronic/partials'

const PX_PER_CATEGORY = 90

interface Props {
  options: ApexCharts.ApexOptions
  series: ApexCharts.ApexOptions['series']
  height?: string
  categoryCount?: number
}

const ProjectMachineBarChart: React.FC<Props> = ({
  options,
  series,
  height = '420px',
  categoryCount = 0,
}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      chart?.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, series, options, categoryCount])

  const refreshChart = () => {
    if (!chartRef.current || !scrollRef.current) return

    const chartHeight = parseInt(getCSS(chartRef.current, 'height')) || 420
    const containerWidth = scrollRef.current.clientWidth || 0
    const neededWidth = Math.max(categoryCount, 1) * PX_PER_CATEGORY
    const chartWidth = Math.max(containerWidth, neededWidth)

    const mergedOptions: ApexCharts.ApexOptions = {
      ...options,
      chart: {
        ...options.chart,
        height: chartHeight,
        width: chartWidth,
      },
      series,
    }

    const chart = new ApexCharts(chartRef.current, mergedOptions)
    chart.render()
    return chart
  }

  return (
    <div ref={scrollRef} style={{ width: '100%', overflowX: 'auto' }}>
      <div ref={chartRef} style={{ height, minWidth: '100%' }} />
    </div>
  )
}

export default ProjectMachineBarChart
